<template>
  <div id="sales-admin-app">
    <SalesAdminPage/>
    <TransitionGroup
        name="toast"
        tag="div"
        class="toast-stack"
        aria-live="polite"
        aria-atomic="true"
        aria-label="Notifications">
      <Toast
          v-for="toast in toasts"
          :key="toast.id"
          :toast="toast"
          @close="removeToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import SalesAdminPage from "./SalesAdminPage.vue";
import Toast from "@components/Toast/Toast.vue";
import { useToast } from "@components/Toast/toast-service";

const { toasts, removeToast } = useToast();
</script>
